import { QueryClient } from "@tanstack/react-query";

// Shared client so dashboard cache survives route changes.
// Defaults stay in place app-wide; dashboard queries set their own staleTime.
export const queryClient = new QueryClient();
